import { ModBoss } from '@vp/mod-father';
import { useContext } from 'react';
import { useSiteData } from '../../hooks/useSiteData';
import { PageModsContext } from '../contexts/PageModsProvider';
import { commonVpDependenciesV1 } from '../../constants/uxMods';
import { modFatherTracker } from '../../apis/trackingApi';
import { useDebugModeContext } from '../contexts/DebugModeContext';

interface PageUxModWrapperProps {
  children: React.ReactNode;
  modHost: string;
}

export const PageUxModWrapper = ({
  modHost,
  children,
}: PageUxModWrapperProps) => {
  const { modBossLogLevel } = useDebugModeContext();
  const { activePageLevelPageUxMods: pageUxMods } = useContext(
    PageModsContext
  ) || { activePageLevelPageUxMods: [] };

  const { locale } = useSiteData();
  const environmentData = {
    commonVpDependenciesV1,
  };

  return (
    <ModBoss
      modHost={modHost}
      consoleOutputLogLevel={modBossLogLevel}
      locale={locale}
      hostTracker={modFatherTracker}
      environmentData={environmentData}
    >
      <ModBoss mods={[...(pageUxMods || [])]}>{children}</ModBoss>
    </ModBoss>
  );
};
